module.exports = __webpack_public_path__ + "media/mighty_boar.a0eef98c.webm";